



















import { defineComponent, getCurrentInstance } from "@vue/composition-api";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import { useToggle } from "@/helpers/hooks/useToggle";
import { sendGaEvent } from "@/helpers/ga-helper";

export default defineComponent({
  name: "ToggleContent",
  components: {
    OccHeading
  },
  props: {
    defaultIsShowContent: {
      type: Boolean,
      default: false
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const [isShowContent, toggle] = useToggle(props.defaultIsShowContent);

    const instance = getCurrentInstance();
    const toggleContent = () => {
      toggle();
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `${props.gaEventCategory}_${
            isShowContent.value ? "開く" : "閉じる"
          }`
        });
      }
    };

    return { isShowContent, toggleContent };
  }
});
